"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveSpecialtiesByCountry = exports.useActiveSpecialtiesByCorporate = void 0;
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 *
 * @param root0 parametros
 * @param root0.corporate coverage a la que se quiere consultar
 * @param root0.type si es consultorio o online
 * @param firestore
 * @param options.corporate
 * @param options.type
 * @param firestore.corporate
 * @param firestore.type
 * @param country
 * @param country.corporate
 * @param country.type
 * @param options opciones de Firestore-hook-options
 * @param queryOptions opciones de React-query
 * @returns que especialidades hay activas por corporate
 */
function useActiveSpecialtiesByCorporate(firestore, { corporate, type }, options, queryOptions) {
    const path = {
        "consultorio": `corporate/${corporate}/specialties_onsite`,
        "online": `corporate/${corporate}/specialties`
    };
    const specialtiesCorporateRef = (0, firestore_2.collection)(firestore, path[type]);
    const specialtiesCorporateQuery = (0, firestore_2.query)(specialtiesCorporateRef, (0, firestore_2.where)("active", "==", true));
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "useActiveSpecialtiesByCorporate",
        path: path[type]
    }, [corporate, type]), specialtiesCorporateQuery, options, {
        ...queryOptions,
        select: (specialties) => {
            return specialties.map(specialty => ({ label: specialty.label, value: specialty.value }));
        }
    });
}
exports.useActiveSpecialtiesByCorporate = useActiveSpecialtiesByCorporate;
/**
 *
 * @param firestore
 * @param country
 * @param options opciones de FirestoreHook
 * @param queryOptions opciones de React-Query
 * @returns las especialidades activas según el país
 */
function useActiveSpecialtiesByCountry(firestore, country, options, queryOptions) {
    const specialtiesCountryRef = (0, firestore_2.collection)(firestore, `parametros/${country}/specialties`);
    const specialtiesCountryQuery = (0, firestore_2.query)(specialtiesCountryRef, (0, firestore_2.where)("active", "==", true));
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "useActiveSpecialtiesByCountry",
        path: `parametros/${country}/specialties`
    }, [country]), specialtiesCountryQuery, options, {
        ...queryOptions,
        select: (specialties) => {
            return specialties.map(specialty => ({ label: specialty.label, value: specialty.value }));
        }
    });
}
exports.useActiveSpecialtiesByCountry = useActiveSpecialtiesByCountry;
